
import React from 'react';
import { UnifiedDerivativeDisplay } from "./UnifiedDerivativeDisplay";
import { DerivativeCreation } from "@/data/models/types";
import { ErrorBoundary } from "@/components/ui/ErrorBoundary";

interface VideoMasonryGridProps {
  items: DerivativeCreation[];
  initialItemsToShow?: number;
  isLoading?: boolean;
  error?: string | null;
  forceVerticalLayout?: boolean;
  showLoadMore?: boolean;
  onLoadMore?: () => void;
  columnCount?: number;
}

export const VideoMasonryGrid = ({
  items,
  initialItemsToShow = 24,
  isLoading = false,
  error = null,
  forceVerticalLayout = true,
  showLoadMore = false,
  onLoadMore,
  columnCount = 3 // Default to 3 columns for the 3x3 grid
}: VideoMasonryGridProps) => {
  return (
    <ErrorBoundary>
      <div className="video-masonry-grid w-full">
        <UnifiedDerivativeDisplay
          items={items}
          isLoading={isLoading}
          error={error}
          displayMode="grid"
          columns={{ sm: 1, md: 2, lg: columnCount, xl: columnCount }} // Set columns to match request
          forceVerticalLayout={forceVerticalLayout}
          className="derivatives-grid"
          showLoadMore={showLoadMore}
          onLoadMore={onLoadMore}
          initialItemsToShow={items?.length || 0} // Show all items passed to this component
        />
      </div>
    </ErrorBoundary>
  );
};
